import {Component, Input, OnInit} from '@angular/core';
import {translateToEnglish} from 'src/app/shared/helpers/string.utils';
import {environment} from '../../../../environments/environment';
import {PopularDoctorModel} from '../../../models/popular-doctor.model';

@Component({
  selector: 'app-popular-doctor',
  templateUrl: './popular-doctor.component.html',
  styleUrls: ['./popular-doctor.component.scss']
})
export class PopularDoctorComponent implements OnInit {
  @Input() doctor!: PopularDoctorModel;
  @Input() isFromMainPage!: boolean
  baseUrl = environment.baseUrl;

  constructor() {
  }

  ngOnInit(): void {
  }

  translateToEnglish(s: string) {
    return translateToEnglish(s);
  }

}
